// extracted by mini-css-extract-plugin
export default {"container":"Tooltip_container__el194","textContainer":"Tooltip_textContainer__iZ3wn","visible":"Tooltip_visible__4hnm-","hidden":"Tooltip_hidden__M-e3r"};